import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "wapper"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "value"
};
const _hoisted_4 = {
  class: "content"
};
const _hoisted_5 = {
  key: 0,
  class: "value"
};
const _hoisted_6 = {
  class: "content"
};
const _hoisted_7 = {
  class: "value"
};
const _hoisted_8 = {
  class: "content"
};
const _hoisted_9 = {
  class: "value"
};
const _hoisted_10 = {
  class: "content"
};
const _hoisted_11 = {
  class: "value"
};
const _hoisted_12 = {
  class: "content"
};
const _hoisted_13 = {
  class: "value"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[6] || (_cache[6] = _createElementVNode("div", {
    class: "title"
  }, "点位详情", -1)), _createElementVNode("div", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("div", {
    class: "trem"
  }, "点位完整名称", -1)), _createElementVNode("div", _hoisted_3, _toDisplayString($props.detail.nodeAllName), 1)]), _createElementVNode("div", _hoisted_4, [_cache[1] || (_cache[1] = _createElementVNode("div", {
    class: "trem"
  }, "支持素材类型", -1)), $props.detail.srcTyp ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.srcType[$props.detail.srcTyp].typ), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [_cache[2] || (_cache[2] = _createElementVNode("div", {
    class: "trem"
  }, "素材格式限制", -1)), _createElementVNode("div", _hoisted_7, _toDisplayString($props.detail.srcTypSuffix), 1)]), _createElementVNode("div", _hoisted_8, [_cache[3] || (_cache[3] = _createElementVNode("div", {
    class: "trem"
  }, "点位规格说明", -1)), _createElementVNode("div", _hoisted_9, _toDisplayString($props.detail.picSize), 1)]), _createElementVNode("div", _hoisted_10, [_cache[4] || (_cache[4] = _createElementVNode("div", {
    class: "trem"
  }, "排序", -1)), _createElementVNode("div", _hoisted_11, _toDisplayString($props.detail.sortNumber), 1)]), _createElementVNode("div", _hoisted_12, [_cache[5] || (_cache[5] = _createElementVNode("div", {
    class: "trem"
  }, "点位描述", -1)), _createElementVNode("div", _hoisted_13, _toDisplayString($props.detail.nodeDesc), 1)])]);
}